"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  Step
} = _antd.Steps;

/**
 * 步驟條
 */

const StepBar = _ref => {
  let {
    current = 0,
    steps = []
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_antd.Steps, {
    current: current
  }, steps.map((step, index) => {
    return /*#__PURE__*/_react.default.createElement(Step, _extends({
      key: index
    }, step));
  }));
};
var _default = exports.default = StepBar;
StepBar.propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    subTitle: _propTypes.default.string
  })),
  current: _propTypes.default.number
};